// These deterministic teaching models do not measure a running game engine.
export function createEconomy() {
  return {tick:0,initialOre:8,ore:8,gathered:0,spent:0,stock:0,crafted:0,delivered:0,unmet:0,history:[{tick:0,ore:8,stock:0,delivered:0,unmet:0}]};
}
export function stepEconomy(state,{source=3,cost=4,demand=1}={}) {
  const s={...state,tick:state.tick+1};
  const input=Math.max(0,Math.floor(source)),recipe=Math.max(1,Math.floor(cost)),orders=Math.max(0,Math.floor(demand));
  s.ore+=input;s.gathered+=input;
  // One workshop has capacity for one item each turn.
  if(s.ore>=recipe){s.ore-=recipe;s.spent+=recipe;s.stock++;s.crafted++;}
  const shipped=Math.min(s.stock,orders);
  s.stock-=shipped;s.delivered+=shipped;s.unmet+=orders-shipped;
  s.history=[...state.history,{tick:s.tick,ore:s.ore,stock:s.stock,delivered:s.delivered,unmet:s.unmet}].slice(-61);
  return s;
}
export function createQuest(){return {version:2,talked:false,keyCollected:false,hasKey:false,door:false,chest:false,reward:false,coins:0};}
export function advanceQuest(state,action){
  const s={...state};
  if(action==='talk')s.talked=true;
  if(action==='key'&&!s.keyCollected){s.keyCollected=true;s.hasKey=true;}
  if(action==='door'&&s.hasKey&&!s.door){s.hasKey=false;s.door=true;}
  if(action==='chest'&&s.door)s.chest=true;
  if(action==='claim'&&s.chest&&s.talked&&!s.reward){s.reward=true;s.coins+=25;}
  return s;
}
export function serializeQuest(state){return JSON.stringify({...state,version:2});}
export function restoreQuest(serialized){
  let raw;
  try{raw=JSON.parse(serialized);}catch{throw new Error('Invalid save');}
  if(!raw||![1,2].includes(raw.version))throw new Error('Unsupported save');
  let s=raw;
  if(raw.version===1){
    if(['keyCollected','doorOpen','chestOpened','rewardClaimed'].some(k=>typeof raw[k]!=='boolean')||!Number.isSafeInteger(raw.gold)||raw.gold<0)throw new Error('Invalid save');
    s={version:2,talked:raw.rewardClaimed,keyCollected:raw.keyCollected,hasKey:raw.keyCollected&&!raw.doorOpen,door:raw.doorOpen,chest:raw.chestOpened,reward:raw.rewardClaimed,coins:raw.gold};
  }
  if(['talked','keyCollected','hasKey','door','chest','reward'].some(k=>typeof s[k]!=='boolean')||!Number.isSafeInteger(s.coins)||s.coins<0)throw new Error('Invalid save');
  if(s.hasKey&&(!s.keyCollected||s.door)||s.door&&!s.keyCollected||s.chest&&!s.door||s.reward&&(!s.chest||!s.talked))throw new Error('Inconsistent save');
  return {state:{version:2,talked:s.talked,keyCollected:s.keyCollected,hasKey:s.hasKey,door:s.door,chest:s.chest,reward:s.reward,coins:s.coins},migrated:raw.version===1};
}
export function frameTimeline({cpu=6,gpu=10,frames=8,hitch=0,hitchFrame=3}={}){
  const result=[];let cpuEnd=0,gpuEnd=0;
  for(let i=0;i<frames;i++){
    const cpuStart=cpuEnd,load=i===hitchFrame?hitch:0;
    cpuEnd=cpuStart+cpu+load;
    const gpuStart=Math.max(cpuEnd,gpuEnd),previousGpuEnd=gpuEnd;
    gpuEnd=gpuStart+gpu;
    result.push({index:i,cpuStart,cpuEnd,load,gpuStart,gpuEnd,interval:i?gpuEnd-previousGpuEnd:null});
  }
  const intervals=result.slice(1).map(f=>f.interval);
  return {frames:result,total:gpuEnd,steadyInterval:Math.max(cpu,gpu),worstInterval:Math.max(0,...intervals),averageInterval:intervals.reduce((a,b)=>a+b,0)/Math.max(1,intervals.length)};
}
